import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

import { clearOnboardingAccountReturn, onboardingAccountReturn } from "~/lib/onboarding-account-callback.ts";

/**
 * ClawInstall OAuth (SSO) return route.
 *
 * Clerk's `<SignIn routing="path">` sends the social-login round-trip back to
 * `<path>/sso-callback`; this route completes the handshake so Google sign-in
 * lands the user inside the ClawInstall experience instead of dead-ending on a
 * missing callback route.
 *
 * When the onboarding account step started the round-trip (CLA-868), a return
 * URL is persisted in `sessionStorage`. Clerk honors the redirect's
 * `redirectUrlComplete` on a fresh sign-up, but DROPS it on a sign-up→sign-in
 * transfer (an already-known Google identity), falling back to the callback's
 * fallback props. We resolve those props from the persisted return URL so the
 * transfer case lands back on `/onboarding/account` carrying the invite context,
 * then clear the marker so a later unrelated login never inherits it. With no
 * stored return (the plain `/login` path) the callback renders bare, exactly as
 * before.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/login/sso-callback")({
  component: ClawInstallSSOCallback,
});

export function ClawInstallSSOCallback() {
  const returnUrl = onboardingAccountReturn();
  if (returnUrl !== null) {
    clearOnboardingAccountReturn();
    return (
      <AuthenticateWithRedirectCallback
        signInFallbackRedirectUrl={returnUrl}
        signUpFallbackRedirectUrl={returnUrl}
      />
    );
  }
  return <AuthenticateWithRedirectCallback />;
}
